var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useState } from 'react';
import { findFolder } from './useFindFolder';
// manage File tree items so they're easier to find and refetch when needed
export function useFileTreeManager() {
    const [items, setItems] = useState([]);
    const updateItem = useCallback((id, updated) => {
        setItems(items => {
            const index = items.findIndex(item => item.id === id);
            if (index < 0) {
                return items.concat(Object.assign({ id, isLoading: false }, updated));
            }
            const copy = Array.from(items);
            const newItem = Object.assign(Object.assign({}, copy[index]), updated);
            copy.splice(index, 1, newItem);
            return copy;
        });
    }, []);
    const loadFile = useCallback((id, params) => __awaiter(this, void 0, void 0, function* () {
        updateItem(id, { isLoading: true });
        const { data, error } = yield findFolder(id, params);
        updateItem(id, { file: data, error, isLoading: false });
    }), [updateItem]);
    const find = useCallback((id) => {
        var _a;
        const item = items.find(item => item.id === id);
        return Object.assign(Object.assign({ id, isLoading: false }, item), { children: ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.children) || [] });
    }, [items]);
    const manager = useMemo(() => {
        return { find, loadFile };
    }, [find, loadFile]);
    return manager;
}
//# sourceMappingURL=useFileTreeManager.js.map